import {Component, OnInit} from '@angular/core';
import {ToolService} from '../../services/tool.service';
import {Observable} from 'rxjs';
import {Tool} from '../../model/tool';
import {CommonModule} from "@angular/common";
import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";
import {ToolBlockComponent} from "../../components/common/tool-block/tool-block.component";
import {ToolTypePipe} from "../../components/common/ToolTypePipe";
import {SortPipe} from "../../components/common/SortPipe";

@Component({
    selector: 'app-tools',
    imports: [
        CommonModule,
        BreadcrumbComponent,
        ToolBlockComponent,
        ToolTypePipe,
        SortPipe,
    ],
    templateUrl: './tools.component.html',
    styleUrls: ['./tools.component.css']
})
export class ToolsComponent implements OnInit {
  tools: Observable<Tool[]>;

  constructor(public toolService: ToolService) {
  }

  ngOnInit(): void {
    this.tools = this.toolService.getObjects();
  }

}
